export default "__VITE_PUBLIC_ASSET__e4870101__"